import { combineSlices } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { emailUserSlice } from './emailUsers'
import { emailFilterSlice } from './emailFilters'
import { emailMetadataSlice } from './emailMetadata'
import { emailTypeSlice } from './emailTypes'
import { emailThreadSlice } from './emailThreads'
import { emailResponseSlice } from './emailResponse'
import { emailResponseClientProfileSlice } from './emailResponseClientProfile'
import { newEmailSlice } from './newEmail'
import { emailAttachmentsSlice } from './emailAttachments'

export default combineSlices(
  emailUserSlice,
  emailFilterSlice,
  emailMetadataSlice,
  emailTypeSlice,
  emailThreadSlice,
  emailResponseSlice,
  emailResponseClientProfileSlice,
  newEmailSlice,
  emailAttachmentsSlice,
)

export const selectEmailHubLoading = (state: RootState) => {
  const {
    emailHub: { emailUsers, emailFilters, emailMetadata, emailTypes, emailThreads },
  } = state

  return (
    emailUsers.isCurrentUserLoading ||
    emailUsers.contactsLoading ||
    emailFilters.isLoading ||
    emailMetadata.isLoading ||
    emailTypes.isLoading ||
    emailThreads.isLoading
  )
}
